export default (type) =>{
    window.dataLayer.push({
        event: type
    });
}